var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11.2889C4 7.26338 7.26338 4 11.2889 4C15.3145 4 18.5779 7.26338 18.5779 11.2889C18.5779 13.0253 17.9707 14.6199 16.957 15.872L19.7753 18.6902C20.0749 18.9898 20.0749 19.4756 19.7753 19.7753C19.4756 20.0749 18.9898 20.0749 18.6902 19.7753L15.872 16.957C14.6199 17.9707 13.0253 18.5779 11.2889 18.5779C7.26338 18.5779 4 15.3145 4 11.2889ZM11.2889 5.53451C8.11087 5.53451 5.53451 8.11087 5.53451 11.2889C5.53451 14.467 8.11087 17.0433 11.2889 17.0433C14.467 17.0433 17.0433 14.467 17.0433 11.2889C17.0433 8.11087 14.467 5.53451 11.2889 5.53451Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.e35afd5e.svg";
export { ForwardRef as ReactComponent };